import { Route } from "@angular/router";

import { checkIfLoggedInFn, numericIdGuard, pmoEntity } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { PageMode } from "../../shared/constants/enums";
import {
  createAgmCyclePageGuards,
  createAgmProjectPageGuards,
  manageAgmCyclePageGuards,
  manageAgmProjectPageGuards,
  viewAgmCyclePageGuards,
  viewAgmMilestonePageGuards,
  viewAgmProjectPageGuards,
  viewAgmSubMenu,
} from "./_guards";

export const AGM_DASHBOARD_ROUTES: Route[] = [
  {
    path: "annual-meetings-projects-dashboard",
    canActivate: [checkIfLoggedInFn],
    children: [
      {
        path: "",
        loadComponent: () => import("./dashboard/agm-dashboard/agm-dashboard").then((e) => e.AgmDashboardComponent),
        canActivate: [...viewAgmProjectPageGuards],
        data: {
          title: "annual_meetings.dashboard",
          breadcrumb: "annual_meetings.dashboard",
        },
      },
      {
        path: "projects",
        children: [
          {
            path: "",
            loadComponent: () =>
              import("./dashboard/agm-cards-dashboard/agm-cards-dashboard").then((e) => e.AgmCardsDashboardComponent),
            canActivate: [...viewAgmProjectPageGuards],
            data: {
              title: "annual_meetings.page_title",
              breadcrumb: "annual_meetings.page_title",
            },
          },
          {
            path: ":id",
            loadComponent: () =>
              import("./agm-project/agm-project-view/agm-project-view").then((e) => e.AgmProjectViewComponent),
            canActivate: [numericIdGuard("/annual-meetings-projects-dashboard"), ...viewAgmProjectPageGuards],
            data: {
              title: "annual_meetings.view",
              breadcrumb: "annual_meetings.view",
            },
          },
        ],
      },
      {
        path: "milestones/:id",
        loadComponent: () =>
          import("./agm-milestone/agm-milestone-view/agm-milestone-view").then((e) => e.AgmMilestoneViewComponent),
        canActivate: [...viewAgmMilestonePageGuards],
        data: {
          title: "annual_meetings.milestones.view",
          breadcrumb: "annual_meetings.milestones.view",
        },
      },
    ],
  },
];

const PROJECT_ROUTES: Route[] = [
  {
    path: "annual-meetings-projects",
    redirectTo: "projects",
  },
  {
    path: "projects",
    canActivate: [...viewAgmProjectPageGuards],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./agm-project/agm-project-list/agm-project-list").then((e) => e.AgmProjectListComponent),
        data: {
          breadcrumb: "annual_meetings.page_title",
          title: "annual_meetings.page_title",
        },
      },
      {
        path: "create",
        loadComponent: () =>
          import("./agm-project/agm-project-editor/agm-project-editor").then((e) => e.AgmProjectEditorComponent),
        canActivate: [...createAgmProjectPageGuards],
        data: {
          breadcrumb: "annual_meetings.create",
          title: "annual_meetings.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./agm-project/agm-project-editor/agm-project-editor").then((e) => e.AgmProjectEditorComponent),
        canActivate: [...manageAgmProjectPageGuards],
        data: {
          breadcrumb: "annual_meetings.edit",
          title: "annual_meetings.edit",
          pageMode: PageMode.edit,
        },
      },
    ],
  },
];

const MILESTONE_ROUTES: Route[] = [
  {
    path: "milestones",
    canActivate: [...viewAgmMilestonePageGuards],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./agm-milestone/agm-milestone-list/agm-milestone-list").then((e) => e.AgmMilestoneListComponent),
        data: {
          breadcrumb: "annual_meetings.milestones.title",
          title: "annual_meetings.milestones.title",
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./agm-milestone/agm-milestone-editor/agm-milestone-editor").then(
            (e) => e.AgmMilestoneEditorComponent
          ),
        data: {
          breadcrumb: "annual_meetings.milestones.edit",
          title: "annual_meetings.milestones.edit",
        },
      },
    ],
  },
];

const CYCLE_ROUTES: Route[] = [
  {
    path: "cycles",
    canActivate: [pmoEntity, ...viewAgmCyclePageGuards],
    children: [
      {
        path: "",
        loadComponent: () => import("./agm-cycle/agm-cycle-list/agm-cycle-list").then((e) => e.AgmCycleListComponent),
        data: {
          breadcrumb: "annual_meetings.cycles.title",
          title: "annual_meetings.cycles.title",
        },
      },
      {
        path: "create",
        canActivate: [...createAgmCyclePageGuards],
        loadComponent: () =>
          import("./agm-cycle/agm-cycle-editor/agm-cycle-editor").then((e) => e.AgmCycleEditorComponent),
        data: {
          breadcrumb: "annual_meetings.cycles.create",
          title: "annual_meetings.cycles.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./agm-cycle/agm-cycle-editor/agm-cycle-editor").then((e) => e.AgmCycleEditorComponent),
        canActivate: [...manageAgmCyclePageGuards],
        data: {
          breadcrumb: "annual_meetings.cycles.edit",
          title: "annual_meetings.cycles.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () =>
          import("./agm-cycle/agm-cycle-editor/agm-cycle-editor").then((e) => e.AgmCycleEditorComponent),
        data: {
          breadcrumb: "annual_meetings.cycles.view",
          title: "annual_meetings.cycles.view",
          pageMode: PageMode.view,
        },
      },
    ],
  },
];

export const AGM_ROUTES: Route[] = [
  {
    path: "annual-meetings-projects",
    canActivate: [checkIfLoggedInFn, ...viewAgmSubMenu],
    data: {
      breadcrumb: "annual_meetings.title",
    },
    children: [
      {
        path: "",
        component: SubmenuComponent,
      },
      ...PROJECT_ROUTES,
      ...MILESTONE_ROUTES,
      ...CYCLE_ROUTES,
    ],
  },
];
